import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import modelHistoryStore from './store';
import { SVGPureIcon } from '@/ui';
import Loader from '@/common/helper/loader';
import EE from '@/common/event';
import agentPageStore from '@/pages/agent-home/store';

const AigentHistory = ({ className = '' }) => {
  const handleHistory = () => {
    modelHistoryStore.getAigentList();
  }
  useEffect(() => {
    EE.on("assistant_history", handleHistory);
    modelHistoryStore.reset();
    modelHistoryStore.getAigentList();
    return () => {
      EE.off("assistant_history", handleHistory);
      modelHistoryStore.reset();
    }
  }, []);

  if (!modelHistoryStore.listData.length) return;

  return (
    <div className={['', className]}>
      {
        modelHistoryStore.listData.slice(0, modelHistoryStore.getTotal()).map((item, index) => {
          if(!item)return null
          return (
            <div
              key={index}
              onClick={evt => {
                agentPageStore.gotoAgentChat(item.id)
              }}
              className="flex items-center mb-8px h-44px pl-6px pr-2px rounded-8px hover:bg-[rgba(0,0,0,0.03)] cursor-pointer"
            >
              <div className="size-32px mr-12px rounded-full overflow-hidden border-1px border-[rgba(0,0,0,0.06)]">
                <img src={Loader.getModelIcon(item)} className="size-full object-contain" alt="" />
              </div>

              <span className="flex-grow w-0 h-44px leading-44px truncate text-16px text-black">
                {item?.title}
              </span>
            </div>
          );
        })
      }
      {modelHistoryStore.getTotal() < modelHistoryStore.listData.length ? (
        <div
          onClick={evt => {
            modelHistoryStore.setPages(modelHistoryStore.pages + 1)
          }}
          className="flex items-center h-44px pl-6px pr-2px rounded-12px hover:bg-[rgba(0,0,0,0.03)] cursor-pointer"
        >
          <div className="size-32px mr-12px rounded-full overflow-hidden border-1px bg-[rgba(0,0,0,0.04)]">
            <SVGPureIcon
              name="model_more"
              className="w-16px ml-8px transform rotate-180"
            />
          </div>
          <span className="text-16px">更多</span>
        </div>
      ) : modelHistoryStore.listData.length > 3
      ? (
        <div
          onClick={evt => {
            modelHistoryStore.setPages(1)
          }}
          className="flex items-center h-44px pl-6px pr-2px rounded-12px hover:bg-[rgba(0,0,0,0.03)] cursor-pointer"
        >
          <div className="size-32px mr-12px rounded-full overflow-hidden border-1px bg-[rgba(0,0,0,0.04)] ">
            <SVGPureIcon
              name="model_fold"
              className="w-16px ml-8px transform "
            />
          </div>
          <span className="text-16px">折叠</span>
        </div>
      )
      : null
    }
    </div>
  );
};

export default observer(AigentHistory);
